import type { QuotaCleanerItem } from 'reactApp/modules/userQuotaCleaner/userQuotaCleaner.types';
import { getSizeInteger } from 'reactApp/utils/sizeHelper';

export const getItemsSize = (items: QuotaCleanerItem[]): number => items.reduce((size, item) => size + getSizeInteger(item.size), 0);
